export default __webpack_public_path__ + "static/media/remove.78416ebf.svg";